<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">我的认购记录</div>

    <el-table v-loading="loading" :data="list" empty-text="暂无认购记录"
      :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="title" label="众筹标题" show-overflow-tooltip></el-table-column>
      <el-table-column prop="issueNumber" label="期号" width="110"></el-table-column>
      <el-table-column label="彩种" width="100">
        <template slot-scope="{ row }">{{ lotteryTypeName(row.lotteryType) }}</template>
      </el-table-column>
      <el-table-column label="每股价格" width="110">
        <template slot-scope="{ row }">{{ money(row.crowdfundingPrice) }} 缩币</template>
      </el-table-column>
      <el-table-column prop="purchaserNumber" label="认购股数" width="100"></el-table-column>
      <el-table-column label="每股分红" width="110">
        <template slot-scope="{ row }">{{ money(row.payablePrice) }} 缩币</template>
      </el-table-column>
      <el-table-column label="应得分红" width="120">
        <template slot-scope="{ row }">{{ money(row.payable) }} 缩币</template>
      </el-table-column>
      <el-table-column prop="bonusStatusIntro" label="派奖状态" width="110"></el-table-column>
      <el-table-column prop="createTime" label="认购时间" width="170"></el-table-column>
      <el-table-column label="操作" width="90" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="goDetail(row.crowdfundingId)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="fenye" v-if="total > 0">
      <el-pagination background layout="prev, pager, next" :total="total"
        :page-size="pageSize" :current-page="pageNum" @current-change="onPage"></el-pagination>
    </div>
  </div>
</template>

<script>
import { bettingShopMySubscribeList } from "@/api/apply";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "MySubscribe",
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      pageSize: 10,
      pageNum: 1,
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    goBack() {
      this.$router.push("/sttzzbfzx/zhaogu");
    },
    goDetail(id) {
      this.$router.push("/sttzzbfzx/zhaogu/detail/" + id);
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[type] || type || "-";
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    loadList() {
      this.loading = true;
      bettingShopMySubscribeList({ pageNum: this.pageNum, pageSize: this.pageSize })
        .then((res) => {
          const rows = (res && res.rows) || (res && res.data && res.data.rows) || [];
          const total = (res && res.total) || (res && res.data && res.data.total) || 0;
          this.list = rows;
          this.total = total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onPage(page) {
      this.pageNum = page;
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}

.fenye {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
